<!--footer section -->
<footer [class]="class">
	<div *ngIf="newsletter">
		<div class="container">
			<section class="small-section border-section border-top-0">
				<div class="row">
					<div class="col-lg-6">
						<div class="subscribe">
							<div>
								<h4>¡CONOCE TODO!</h4>
								<p>Recibe las ofertas, noticias y descuentos exclusivos cada semana.</p>
							</div>
						</div>
					</div>
					<div class="col-lg-6">
						<form class="form-inline subscribe-form"
							action="https://pixelstrap.us19.list-manage.com/subscribe/post?u=5a128856334b598b395f1fc9b&amp;id=082f74cbda"
							target="_blank" method="post">
							<div class="form-group mx-sm-3">
								<input type="email" #name name="EMAIL" id="mce-EMAIL" class="form-control"
									[(ngModel)]="mail" placeholder="Ingresa tu correo electrónico">
							</div>
							<button type="submit" class="btn btn-solid" (click)="goToRegister()">REGÍSTRATE</button>
						</form>
					</div>
				</div>
			</section>
		</div>
	</div>
	<section class="section-b-space-footer">
		<div class="container">
			<div class="row footer-theme partition-f">
				<div class="col-lg-4 col-md-6">
					<div class="footer-title footer-mobile-title">
						<!-- <h4>about</h4> -->
					</div>
					<div class="footer-contant">
						<div class="footer-logo">
							<img [ngSrc]="themeLogo" alt="logo" class="img-fluid" width="237"
								height="75" loading="lazy" />
						</div>
						<!-- <p>Conoce la mejor experiencia en compras, entérate de todos los productos que ofrecemos en una amplia variedad de productos de alta calidad 
							asegurandonos de que puedas encontrar todo lo que necesitas.</p> -->
						<div class="footer-social">
							<ul>
								<li>
									<a href="https://www.facebook.com/gigmaxmx" target="_blank"><i class="fa fa-facebook" aria-hidden="true"></i></a>
								</li>
								<li>
									<a href="https://www.instagram.com/gigmaxmx" target="_blank"><i class="fa fa-instagram" aria-hidden="true"></i></a>
								</li>
								<li>
									<a href="https://www.linkedin.com/company/gigmaxmx/" target="_blank"><i class="fa fa-linkedin" aria-hidden="true"></i></a>
								</li>
								<li>
									<a href="https://www.youtube.com/@gigmaxmx" target="_blank"><i class="fa fa-youtube " aria-hidden="true"></i></a>
								</li>
								<!-- <li>
                                    <a href="https://www.tiktok.com/@bestticketmx" tarjet="_blank">
										<img src="assets/images/icon/tik-tok.png" alt="TikTok Icon" style="height: 19px; margin-top: -7px!important;">
									</a>
                                </li> -->
								<!-- <li>
                                    <a href="javascript:void(0)"><i class="fa fa-rss" aria-hidden="true"></i></a>
                                </li> -->
							</ul>
						</div>
					</div>
				</div>
				<div class="col offset-xl-1">
					<div class="sub-title">
						<div class="footer-title">
							<h4>Categorías</h4>
						</div>
						<div class="footer-contant">
							<ul>
								<li><a [routerLink]="['/home/watch']">Inicio</a></li>
								<li><a [routerLink]="['/shop/wishlist']">Mi lista de deseos</a></li>
								<li><a [routerLink]="['/pages/aviso']">Aviso de Privacidad</a></li>
								<li><a [routerLink]="['/pages/condiciones-envio']">Políticas de envío</a></li>
								<li><a [routerLink]="['/pages/terminos-y-condiciones']">Términos y Condiciones</a></li>
								<!-- <li><a [routerLink]="['/pages/listar-metodo-pago']">Formas de Pago</a></li> -->
								<!-- <li><a href="'/shop/collection/left/sidebar'">Celulares</a></li>
                                <li><a href="'/shop/collection/left/sidebar'">Gadgets</a></li> -->
								<!--<li><a href="javascript:void(0)">Kids Fashion</a></li>
                                <li><a href="javascript:void(0)">Featured</a></li>-->
							</ul>
						</div>
					</div>
				</div>
				<div class="col">
					<div class="sub-title">
						<div class="footer-title">
							<h4>¿Por qué elegirnos?</h4>
						</div>
						<div class="footer-contant">
							<ul>
								<li><a [routerLink]="['/shop/collection/left/sidebar']">Productos</a></li>
								<li><a [routerLink]="['/pages/contact']">Contacto</a></li>
								<li><a [routerLink]="['/pages/terminos-y-condiciones']">Términos y condiciones</a></li>
								<li><a [routerLink]="['/pages/aviso']">Aviso de Privacidad</a></li>
								<!--<li><a href="javascript:void(0)">Contacto</a></li>-->
							</ul>
						</div>
					</div>
				</div>
				<!-- <div class="col">
					<div class="sub-title">
						<div class="footer-title">
						    <h4>más información</h4>
						</div>
						<div class="footer-contant">
						    <ul class="contact-list">
						        <li><i class="fa fa-map-marker"></i>Avenida División del Norte 3454, planta baja, despacho 2, Colonia Xotepingo,
						            Coyoacán, Ciudad de México. CP. 04331.</li>
						        <li><i class="fa fa-phone"></i>Llámanos: +52 55 62 01 72 00</li>
						        <li><i class="fa fa-envelope-o"></i>Correo: <a>contacto@izzitelefonia.mx</a></li>
						        <li><i class="fa fa-fax"></i>Contacto: integraciones.validacion@openpay.mx</li>
						    </ul>
						</div>
					</div>
				</div> -->
			</div>
		</div>
	</section>
	<div class="sub-footer">
		<div class="container">
			<div class="row">
				<div class="col-xl-5 col-md-5 col-sm-12">
					<div class="footer-end">
						<p><i class="fa fa-copyright" aria-hidden="true"></i>{{ today | date:'y'}} http://GIGMAX.mx/
						</p>
					</div>
				</div>
				<div class="col-xl-6 col-md-6 col-sm-12">
					<div class="payment-card-bottom">
						<ul>
							<li>
								<a><img src="assets/images/icon/visa.png" alt="" style="width: 26px !important;"></a>
							</li>
							<li>
								<a><img src="assets/images/icon/master.png" alt="" style="width: 26px !important;"></a>
							</li>
							<li>
								<a><img src="assets/images/icon/amex.png" alt="" style="width: 26px !important;"></a>
							</li>
							<li>
								<a href="javascript:void(0)">
									<img src="assets/images/icon/carnet.png" alt="" style="width: 26px !important;">
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</footer>
<!--footer section end -->